import React from 'react';

import { RedoOutlined } from '@ant-design/icons';

import moment from 'moment';

import { getEventTypeColor, getEventCategoryColor } from './../../../utils/color-utils';
import EventPopover from './event-popover';

import './card-event.less';

const CardEvent = (props) => {
  const { eventItem: item, onEditEvent, onDeleteEvent, rootContainer, calendarCategories } = props;

  const itemBackgroundColor = getEventCategoryColor(calendarCategories, item);
  const mainBorderColor = getEventTypeColor(item);

  return (
    <EventPopover item={item} onEditEvent={onEditEvent} onDeleteEvent={onDeleteEvent} rootContainer={rootContainer}>
      <div
        title={item.content}
        className="calendar-custom-mode-event"
        style={{
          top: item.positions.start + 'px',
          height: item.positions.height + 'px',
          width: item.positions.width + '%',
          left: item.positions.left + '%',
          zIndex: item.positions.zIndex,
          backgroundColor: itemBackgroundColor,
          borderColor: mainBorderColor,
          borderLeftColor: mainBorderColor,
        }}
      >
        <div className="calendar-custom-mode-event-title">{item.subject}</div>
        <div className="calendar-custom-mode-event-location">{moment(item.start).format('hh:mm a') + ' - ' + moment(item.end).format('hh:mm a')}</div>
        {item.recurrenceObject && (
          <div className="calendar-custom-mode-event-recurring">
            <RedoOutlined style={{ paddingRight: '2px' }} />
          </div>
        )}
      </div>
    </EventPopover>
  );
};

export default CardEvent;
